import { REDUX_ACTIONS, GAME_ID } from 'a/directorsCut/data/constants';

const initState = {
  x: 0,
  y: 0,
  w: 0,
  h: 0,
};

const dropZoneReducer = (state = initState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.SET_DROP_ZONE:
      return payload;

    case REDUX_ACTIONS.ROUND_END: {
      return {
        ...initState,
      };
    }

    default:
      return state;
  }
};

export default dropZoneReducer;
